import React from "react";
import { baseURL } from "../../globalUtils/axiosConfig";

const SemesterSection = ({ data, report_type, report_period }) => {
  const {
    user = {},
    teachers = [],
    class: classInfo = {},
    report_log = {},
  } = data || {};

  const { first_name = "", last_name = "", year_level = "", login_id = "", image_path = "" } = user;

  const fullName = `${first_name} ${last_name}`;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  return (
    <div className="" style={{ marginTop: "5px" }}>
      <div
        className="pdf-page"
        style={{
          width: "210mm",
          height: "297mm",
          padding: "20mm",
          boxSizing: "border-box",
          backgroundColor: "white",
          backgroundImage: "url('/quran_4.jpg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          position: "relative",
          fontFamily: "Arial, sans-serif",
          fontWeight: "bold",
          color: "#333",
        }}
      >

        <img
          src="/apple-touch-icon.png"
          alt="Logo"
          style={{ width: "120px", position: "absolute", top: "20mm", right: "20mm" }}
        />

        <div style={{ textAlign: "center", marginTop: "5px", marginBottom: "40px" }}>
          <h1 style={{ fontSize: "32px", fontWeight: "bold", color: "#222" }}>{report_log?.report_type?.toUpperCase() || "SEMESTER"}</h1>
          <div style={{ fontSize: "24px", marginTop: "10px", color: "#555" }}>
            <div style={{ fontSize: "18px", fontWeight: "bold", color: "#777", marginBottom: "5px" }}>
              {report_period?.toUpperCase() || "Report Period"}
            </div>
            {classInfo?.name ? `${classInfo.name} - ${classInfo.code}` : "CLASS"}
          </div>
          <h3 style={{ fontSize: "20px", color: "#555", marginTop: "20px" }}>{fullName}</h3>
        </div>

        <div style={{
          fontSize: "16px",
          textAlign: "left",
          marginTop: "60px",
          lineHeight: 1.5,
        }}>
          <img
            src={image_path ? `${baseURL}/${image_path}` : "/download.png"}
            alt="Profile"
            style={{ width: "120px", position: "absolute", top: "20mm", left: "20mm" }}
          />
          <div style={{ marginRight: "140px", marginTop: 0 }}>
            <p><strong>Student ID:</strong> {login_id}</p>
            <p><strong>Year Level:</strong> {year_level}</p>
            <p><strong>Start Date:</strong> {formatDate(report_log?.metadata?.start_date)}</p>
            <p><strong>End Date:</strong> {formatDate(report_log?.metadata?.end_date)}</p>
            <p>
              <strong>Teacher{teachers.length > 1 ? "s" : ""}:</strong> {teachers.map((t) => t.name).join(", ")}
            </p>
          </div>
        </div>


      </div>
    </div>
  );
};

export default SemesterSection;
